// Custom theme colours
const themeColors = {
  m15blue: '#213DDE',
  m15lightblue: '#3ab8ff',
};

// Background colours
const backgroundColors = {
  backgroundLight: '#ffffff',
  backgroundDark: '#000000',
  backgroundSecondary: '#f1f6f8',
  backgroundTertiary: '#3ab8ff',
};

// Theme variant colours
const themeVariantColors = {
  themeLightMain: '#000000',
  themeLightInverse: '#ffffff',
  themeLightBackground: backgroundColors.backgroundLight,
  themeDarkMain: '#ffffff',
  themeDarkInverse: '#000000',
  themeDarkBackground: backgroundColors.backgroundDark,
  themeSecondaryMain: '#000000',
  themeSecondaryInverse: '#213dde',
  themeSecondaryBackground: backgroundColors.backgroundLight,
  themeTertiaryMain: '#3ab8ff',
  themeTertiaryInverse: '#000000',
  themeTertiaryBackground: '',
};

// Core colours override
const coreColors = {
  headingsText: '#000000',
  bodyText: '#000000',
  overlayText: '#ffffff',
  linkText: '#213DDE',
  linkHover: '#3ab8ff',
  buttonBorder: '#ffffff',
  buttonBackground: '#ffffff',
  buttonText: '#213DDE',
  buttonBorderHover: '#213DDE',
  buttonBackgroundHover: '#213DDE',
  buttonTextHover: '#ffffff',
  buttonAltBorder: '#213DDE',
  buttonAltBackground: '#213DDE',
  buttonAltText: '#ffffff',
  buttonAltBorderHover: '#213DDE',
  buttonAltBackgroundHover: '#ffffff',
  buttonAltTextHover: '#213DDE',
  interactiveBorder: '#213DDE',
  interactiveBackground: '#f1f6f8',
  interactiveText: '#213DDE',
  interactiveBorderHover: '#ffffff',
  interactiveBackgroundHover: '#ffffff',
  interactiveTextHover: '#213DDE',
  navigationLinkText: '#213DDE',
  navigationLinkHover: '#3ab8ff',
  headerBackground: '#f1f6f8',
  bodyBackground: '#f1f6f8',
  footerBackground: '#213DDE',
  footerSubBackground: '#3AB8FF',
  footerLinkText: '#ffffff',
  footerLinkHover: '#3ab8ff',
  formInputBorder: '#000000',
  formInputBorderError: '#F43319',
  formInputBackground: '#f1f6f8',
  formInputText: '#000000',
  formErrorText: '#F43319',
  itemBorder: '#1d1f22',
  dropShadow: 'transparent',
  loadingIndicator: '#3AB8FF',
  socialIcon: '#ffffff',

  headingsTextDark: '#ffffff',
  bodyTextDark: '#ffffff',
  overlayTextDark: '#ffffff',
  linkTextDark: '#ffffff',
  linkHoverDark: '#e1e1e1',
  buttonBorderDark: '#000000',
  buttonBackgroundDark: '#ffffff',
  buttonTextDark: '#000000',
  buttonBorderHoverDark: '#000000',
  buttonBackgroundHoverDark: '#f5f3f5',
  buttonTextHoverDark: '#000000',
  buttonAltBorderDark: '#ffffff',
  buttonAltBackgroundDark: 'rgba(255, 255, 255, 0)',
  buttonAltTextDark: '#000000',
  buttonAltBorderHoverDark: '#ffffff',
  buttonAltBackgroundHoverDark: '#f5f3f5',
  buttonAltTextHoverDark: '#000000',
  interactiveBorderDark: '#000000',
  interactiveBackgroundDark: '#000000',
  interactiveTextDark: '#ffffff',
  interactiveBorderHoverDark: '#1d1f22',
  interactiveBackgroundHoverDark: '#1d1f22',
  interactiveTextHoverDark: '#efefef',
  navigationLinkTextDark: '#ffffff',
  navigationLinkHoverDark: '#f5f3f5',
  footerLinkTextDark: '#ffffff',
  footerLinkHoverDark: '#f5f3f5',
  headerBackgroundDark: '#000000',
  bodyBackgroundDark: '#1d1f22',
  footerBackgroundDark: '#000000',
  footerSubBackgroundDark: '#000000',
  formInputBorderDark: '#000000',
  formInputBorderErrorDark: '#F43319',
  formInputBackgroundDark: '#ffffff',
  formInputTextDark: '#000000',
  formErrorTextDark: '#F43319',
  itemBorderDark: '#000000',
  dropShadowDark: 'rgba(255, 255, 255, 0)',
  loadingIndicatorDark: '#ffffff',
  socialIconDark: '#ffffff',
};

// Theme classes for custom styling
const themeVariants = [];

const fontFamily = {
  primary: ['DM Sans', 'sans-serif'],
  secondary: ['Space Grotesk', 'sans-serif'],
};

// Override font sizes as required
const themeFontSizes = {
  // H1
  '7xl': [
    '58px',
    {
      lineHeight: '65px',
      letterSpacing: '0',
      fontWeight: '700',
    },
  ],
  '6xl': [
    '58px',
    {
      lineHeight: '65px',
      letterSpacing: '0',
      fontWeight: '700',
    },
  ],
  '5xl': [
    '58px',
    {
      lineHeight: '65px',
      letterSpacing: '0',
      fontWeight: '700',
    },
  ],
  // H2
  '4xl': [
    '34px',
    {
      lineHeight: '40px',
      letterSpacing: '0',
      fontWeight: '600',
    },
  ],
  // H3
  '3xl': [
    '26px',
    {
      lineHeight: '29px',
      letterSpacing: '0',
      fontWeight: '600',
    },
  ],
  // H4
  '2xl': [
    '26px',
    {
      lineHeight: '29px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  // H5
  xl: [
    '26px',
    {
      lineHeight: '29px',
      letterSpacing: '0',
      fontWeight: '400',
    },
  ],
  // H6
  lg: [
    '26px',
    {
      lineHeight: '29px',
      letterSpacing: '0',
      fontWeight: '400',
    },
  ],
  md: [
    '24px',
    {
      lineHeight: '29px',
      letterSpacing: '0',
      fontWeight: '300',
    },
  ],
  base: [
    '20px',
    {
      lineHeight: '26px',
      letterSpacing: '0',
      fontWeight: '300',
    },
  ],
  sm: [
    '16px',
    {
      lineHeight: '22px',
      letterSpacing: '0',
      fontWeight: '300',
    },
  ],
  xs: [
    '14px',
    {
      lineHeight: '20px',
      letterSpacing: '0',
      fontWeight: '300',
    },
  ],
};

const spacing = {
  'vertical-nav': '200px',
  'header-height': '150px',
  'header-height-scrolled': '90px',
  'mobile-header-height': '60px',
};

module.exports = {
  themeColors,
  backgroundColors,
  themeVariantColors,
  coreColors,
  themeVariants,
  fontFamily,
  themeFontSizes,
  spacing,
};
